import { TReduxActions } from '../../types/redux';
import { IConsultationRequestState } from '../../types/redux/consultationRequest';
import { EConsultationRequestActions } from '../../constants/actionTypes/consultationRequest';

export const defaultState: IConsultationRequestState = {
  isModalOpen: false,
};

export function consultationRequestReducer(
  state: IConsultationRequestState = defaultState,
  action: TReduxActions,
): IConsultationRequestState {
  switch (action.type) {
    case EConsultationRequestActions.SetModalOpen:
      return {
        ...state,
        isModalOpen: action.payload,
      };

    default:
      return state;
  }
}
